(() => {
  const root = document.querySelector('[data-rfq-endpoint]');
  if (!root) return;
  const form = root.querySelector('form');
  const input = root.querySelector('[data-rfq-files]');
  const status = root.querySelector('[data-rfq-status]');
  const links = root.querySelector('[data-rfq-links]');
  const field = root.querySelector('[data-rfq-attachments]');
  const extensions = /\.(jpe?g|png|webp|pdf|zip|docx)$/i;
  let pending = null, generation = 0, waiting = false;
  input.hidden = false;
  input.classList.toggle('rfq-has-files', input.files.length > 0);
  function message(text) { status.textContent = text; }
  input.addEventListener('change', () => {
    const current = ++generation;
    field.value = ''; links.replaceChildren(); input.setCustomValidity('');
    const files = Array.from(input.files);
    input.classList.toggle('rfq-has-files', files.length > 0);
    if (!files.length) { pending = null; message(''); return; }
    if (files.length > 5 || files.some(f => !extensions.test(f.name) || !f.size || f.size > 5242880)) {
      input.setCustomValidity('Choose up to 5 supported files, each no larger than 5 MB.');
      message(input.validationMessage); pending = null; return;
    }
    input.setCustomValidity('Please wait for your attachments to finish uploading.');
    message('Uploading attachments…');
    pending = (async () => {
      try {
        const response = await fetch(root.dataset.rfqEndpoint.replace(/\/$/, '') + '/sign', {
          method: 'POST', headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({files: files.map(f => ({name: f.name, size: f.size}))})
        });
        if (!response.ok) throw new Error('Attachment service unavailable. Please try again.');
        const result = await response.json();
        for (let i = 0; i < files.length; i++) {
          if (current !== generation) return false;
          const item = result.uploads[i], body = new FormData();
          Object.entries(item.fields).forEach(([k, v]) => body.append(k, v));
          body.append('file', files[i]);
          const uploaded = await fetch(item.url, {method: 'POST', body});
          if (!uploaded.ok) throw new Error('Upload failed. Please select your attachments again.');
        }
        if (current !== generation) return false;
        field.value = result.uploads.map(item => item.name + ': ' + item.download).join('\n');
        result.uploads.forEach(item => {
          const li = document.createElement('li'), a = document.createElement('a');
          a.textContent = item.name; a.href = item.download; a.target = '_blank'; a.rel = 'noopener';
          li.append(a); links.append(li);
        });
        input.setCustomValidity('');
        message('Attachments uploaded.');
        return true;
      } catch (error) {
        if (current === generation) { input.setCustomValidity(error.message); message(error.message); }
        return false;
      } finally { if (current === generation) pending = null; }
    })();
  });
  // Upload validation blocks native submit until uploads complete; Shopify then
  // receives the normal contact form, including its spam protection.
  form.addEventListener('submit', async event => {
    if (!pending) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (waiting) return;
    waiting = true;
    const current = generation, task = pending;
    const ok = await task;
    waiting = false;
    if (ok && current === generation) form.requestSubmit(event.submitter || undefined);
  }, true);
})();
